import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs';
import { data_get, data_nullify, fallback } from '../../../utils/common';
import { FieldmagicDropdownOption } from '../../forms/input/dropdown/dropdown.component';

@Component({
  selector: 'app-reason-dialog',
  templateUrl: './reason-dialog.component.html',
  styleUrls: ['./reason-dialog.component.scss']
})
export class ReasonDialogComponent implements OnInit {

  options: FieldmagicDropdownOption<Record<string, any>>[] = [];

  reason?: FieldmagicDropdownOption<Record<string, any>>;
  markTasksAsComplete: boolean = false;

  readonly showCompleteTasks$ = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly _dialog: MatDialogRef<ReasonDialogComponent, ReasonDialogResult>,
    @Inject(MAT_DIALOG_DATA) private readonly _data: ReasonDialogData,
  ) {}

  ngOnInit() {
    this.options = fallback(data_get(this._data, 'options'), {
      fallback: () => [],
    });

    this.reason = data_nullify(data_get(this._data, 'default_value'));
    this.showCompleteTasks$.next(data_get(this._data, 'show_complete_tasks'));
  }

  onSave(): void {
    this._dialog.close({
      reason: data_get(this.reason, 'id'),
      mark_tasks_as_complete: this.markTasksAsComplete,
    });
  }
}

export type ReasonDialogData = {
  options: FieldmagicDropdownOption<Record<string, any>>[];
  show_complete_tasks?: boolean;
  default_value?: string;
}

export type ReasonDialogResult = {
  reason?: string;
  mark_tasks_as_complete?: boolean;
}